export class GetIntegrations {
  static readonly type = '[Integrations] GetIntegrations';
  constructor() {}
}

export class GetIntegrationDetail {
  static readonly type = '[IntegrationActivities] GetIntegrationDetail';

  /**
   *
   * @param customerIntegrationId Number - DB_saasConfigurations.integrationActivities.customerIntegrationId
   */
  constructor(
    public customerIntegrationId: number,
  ) {}
}

export class GetIntegrationActivities {
  static readonly type = '[IntegrationActivities] GetIntegrationActivities';
  /**
   *
   * @param customerIntegrationId Number - DB_saasConfigurations.integrationActivities.customerIntegrationId
   * @param page Number - page index
   */
  constructor(
    public customerIntegrationId: number,
    public page: number = 0,
  ) {}
}
